import React from 'react';
import gif from '../assets/images/loading.gif';

class Loading extends React.Component {

	render() {
		return (
			<div className="loading-container">
				<img src={gif} className="loading" alt="loading" />
			</div>
		);
	}
}

export default Loading;